import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Programme } from '../types/programme';
import { VoxPopService } from '../services/voxpop.service';
import { ProfileService } from "../services/profile.service";

@Component({
  selector: 'programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['../shared/entity-list.css'],
  providers: [VoxPopService],
  standalone: false
})


export class ProgrammesComponent implements OnInit {
  CanReview = ProfileService.CanReview;
  CanAdminister = ProfileService.CanAdminister;
  adding: boolean = false;
  programmes: Programme[];
  allProgrammes: Programme[];
  errorMessage: string;
  loading = false;
  currentProgramme: Programme;

  constructor(
    private voxPopService: VoxPopService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;
    this.getProgrammes();
    document.getElementById("title").innerText = 'Programmes';
  }

  getProgrammes(): void {
    this.loading = true;
    this.errorMessage = '';
    this.voxPopService.activeProgrammes().subscribe(
      programmes => this.updatedProgrammes(programmes),
      () => { this.errorMessage = 'Could not load programmes. Please retry.'; this.loading = false; },
    );
  }

  private updatedProgrammes(newProgrammes: Programme[]): void {
    this.allProgrammes = newProgrammes;
    this.programmes = newProgrammes || [];
    this.loading = false;
    console.log("Updated programmes " + this.programmes.length);
  }

  gotoDetail(programme: Programme): void {
    this.router.navigate(['/review/programme/', programme.id]);
  }

  addProgramme(): void {
    this.adding = true;
  }

  cancelInsert(): void {
    this.adding = false;
  }

  getColorFor(programme: Programme): string {
    if (this.errorMessage && programme) return '#ff8080'; // So editor doesn't make me think this can be static
    return '#EEEEEE';
  }

}

